import type { BoardDiagramV3 } from "./types";

interface RemoveBoardItemGroupFromDiagramArgs {
  diagram: BoardDiagramV3;
  diagramItemTypeId: number;
}

export const removeBoardItemGroupFromDiagram = ({
  diagram,
  diagramItemTypeId,
}: RemoveBoardItemGroupFromDiagramArgs): BoardDiagramV3 => {
  const itemTypes = diagram.itemTypes.filter(
    (itemType) => itemType.diagram_item_type_id !== diagramItemTypeId,
  );

  const totalCount = itemTypes.reduce(
    (sum, itemType) => sum + itemType.totalCount,
    0,
  );

  return { ...diagram, itemTypes, totalCount };
};
